export default "__VITE_ASSET__COEFbZ8D__"